import { memo, type ReactNode } from "react";
import { RefreshCw } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

interface MobilePageHeaderProps {
  title: string;
  icon?: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
  rightSlot?: ReactNode;
}

const MobilePageHeader = memo(({
  title,
  icon,
  onRefresh,
  isRefreshing,
  rightSlot,
}: MobilePageHeaderProps) => {
  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur-sm border-b border-border/50">
      <div className="px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          {icon && <span className="shrink-0">{icon}</span>}
          <h1 className="text-base font-semibold text-foreground truncate">{title}</h1>
        </div>

        <div className="flex items-center gap-1.5 shrink-0">
          {onRefresh && (
            <button
              onClick={onRefresh}
              disabled={isRefreshing}
              className="p-2 rounded-lg bg-secondary/30 border border-border/50 disabled:opacity-50 active:scale-95 transition-transform"
              aria-label="Aktualisieren"
            >
              <RefreshCw
                size={16}
                className={isRefreshing ? "animate-spin text-muted-foreground" : "text-muted-foreground"}
              />
            </button>
          )}
          {rightSlot}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
});

MobilePageHeader.displayName = "MobilePageHeader";

export default MobilePageHeader;
